import { EmailForm } from './email-form';
import { match } from 'ts-pattern';
import { PostcodeForm } from './postcode-form';
import { CustomerIdForm } from './customer-id-form';
import { VerifyAccountForm } from './verify-account-form';
import { ConfirmOTPForm } from './confirm-otp-form';
import { useGlobalStore } from '@/stores/store';
import { AuthHeader } from './auth-header';

const AuthForm = () => {
  const currentStep = useGlobalStore(
    (store) => store.authStore.authFlow.currentStep
  );
  return (
    <div>
      <div className="lg:mb-10">
        <AuthHeader />
      </div>
      <div className="flex flex-col pt-4 pb-16 lg:pt-0 lg:pb-0">
        {match(currentStep)
          .with('email', () => <EmailForm />)
          .with('postcode', () => <PostcodeForm />)
          .with('customerId', () => <CustomerIdForm />)
          .with('verifyAccount', () => <VerifyAccountForm />)
          .with('confirmOTP', () => <ConfirmOTPForm />)
          .exhaustive()}
      </div>
    </div>
  );
};

export { AuthForm };
